<app-header></app-header>
<app-menus></app-menus>

<app-alert-banner></app-alert-banner>

<div id="app-content">
  <div id="main-content">Main section</div>

  <app-chips></app-chips>

  <app-pageloader></app-pageloader>

  <div *ngIf="showModal">
    <login-modal></login-modal>
  </div>
  <router-outlet></router-outlet>
</div>

<app-footer></app-footer>

<app-timeout-popup [envPortal]="portalVariable" (tokenRefreshLink)="callTokenRefresh()"></app-timeout-popup>
<div id="version" style="position: absolute;visibility:hidden">{{version}}</div>